// side effects 
import "core-js/stable";
import "regenerator-runtime/runtime";
import './filters/format'
import './plugins'
import 'bootstrap'

import App from './App'
import Fragment from 'vue-fragment'
import Vue from 'vue'
import router from './router'
import { store, initializeStores } from './store'

import vSelect from 'vue-select'
import DatePicker from './components/DatePicker.vue'

import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

Sentry.init({
  dsn: window.envConfig.UI_SENTRY_DSN,
  environment: window.envConfig.SENTRY_ENVIRONMENT || 'prod',
  integrations: [
    new Integrations.Vue({ Vue, attachProps: true, logErrors: true }),
  ],
})

Vue.component('v-select', vSelect)
Vue.component('date-picker', DatePicker)

/*
import VueAnalytics from 'vue-analytics'
Vue.use(VueAnalytics, {
    id: '',
    router
})
*/

Vue.config.productionTip = false
Vue.use(Fragment.Plugin)

if (!window.envConfig.API_BASEURL) {
  window.envConfig.API_BASEURL =
    window.location.protocol + '//' + window.location.host
}

// Start timer. Provides a reactive timestamp, updated each second
//store.dispatch("time/start");

const startApp = () => {
  // Launch vue app!
  window.Vue = new Vue({
    el: '#app',
    render: (h) => h(App),
    router,
    store,
    beforeCreate() {
      initializeStores.apply(this)
    },
  })
}

store
  .dispatch('user/loadUser')
  .then(async function () {
    try {
      Sentry.setUser({ id: store.state.user.profile.userId })
    } catch (e) {
      console.error(e)
    }
    // Go to /logout when access token expires
    store.dispatch('user/autoLogout', function () {
      store.dispatch('app/logout')
    })

    startApp()
  })
  .catch((error) => {
    if (error.response && error.response.status === 401) {
      window.location =
        window.envConfig.AUTH_BASEURL + '?goto=' + window.location
    } else {
      startApp()
    }
  })
